export enum HowYouFindQreamValue {
	Clutch = 'clutch',
	Google = 'google',
	LinkedIn = 'linkedIn',
	Dribbble = 'dribbble',
	Behance = 'behance',
	Upwork = 'upwork',
	Referral = 'referral',
	Event = 'event',
	Award = 'award',
	AI = 'ai',
	NotSure = 'notSure',
	Other = 'other'
}

export const howYouFindQreamOptions = [
	{ label: 'Clutch', value: HowYouFindQreamValue.Clutch },
	{ label: 'Google', value: HowYouFindQreamValue.Google },
	{ label: 'LinkedIn', value: HowYouFindQreamValue.LinkedIn },
	{ label: 'Dribbble', value: HowYouFindQreamValue.Dribbble },
	{ label: 'Behance', value: HowYouFindQreamValue.Behance },
	{ label: 'Upwork', value: HowYouFindQreamValue.Upwork },
	{ label: 'Referral', value: HowYouFindQreamValue.Referral },
	{ label: 'Event', value: HowYouFindQreamValue.Event },
	{ label: 'Award', value: HowYouFindQreamValue.Award },
	{ label: 'AI (ChatGPT, Perplexity)', value: HowYouFindQreamValue.AI },
	{ label: 'Not sure', value: HowYouFindQreamValue.NotSure },
	{ label: 'Other', value: HowYouFindQreamValue.Other }
];
